import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { MainLayoutComponent } from "./main-layout/main-layout.component";
import { AuthGuard } from "../../Guards/auth.guard";

const routes: Routes = [
  {
    path: "",
    component: MainLayoutComponent,
    children: [
      {
        path: "marihub-portal",
        loadChildren: () =>
          import("./../../Pages/MariHub-Portal/mari-hub-portal.module").then(
            (modules) => modules.MariHubPortalModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "personal",
        loadChildren: () =>
          import(
            "./../../Pages/Personal-Informations/personal-information.module"
          ).then((modules) => modules.PersonalInformationModule),
        canActivate: [AuthGuard],
      },
      {
        path: "dashboard",
        loadChildren: () =>
          import("./../../Pages/DashBoard/dash-board.module").then(
            (modules) => modules.DashBoardModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "shop",
        loadChildren: () =>
          import("./../../Pages/Shop/shop.module").then(
            (modules) => modules.ShopModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "shopping",
        loadChildren: () =>
          import("./../../Pages/Shopping/shopping.module").then(
            (modules) => modules.ShoppingModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "order",
        loadChildren: () =>
          import("./../../Pages/Order/order.module").then(
            (modules) => modules.OrderModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "client",
        loadChildren: () =>
          import("./../../Pages/Client/client.module").then(
            (modules) => modules.ClientModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "ports",
        loadChildren: () =>
          import("./../../Pages/Ports/ports.module").then(
            (modules) => modules.PortsModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "vendors",
        loadChildren: () =>
          import("./../../Pages/Vendor/vendor.module").then(
            (modules) => modules.VendorModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "analytics-and-reports",
        loadChildren: () =>
          import(
            "./../../Pages/Analytics-And-Reports/analytics-and-reports.module"
          ).then((modules) => modules.AnalyticsAndReportsModule),
        canActivate: [AuthGuard],
      },
      {
        path: "system-category",
        loadChildren: () =>
          import("./../../Pages/System-Category/system-category.module").then(
            (modules) => modules.SystemCategoryModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "product-catalogue",
        loadChildren: () =>
          import(
            "./../../Pages/Product-Catalogue/product-catalogue.module"
          ).then((modules) => modules.ProductCatalogueModule),
        canActivate: [AuthGuard],
      },
      {
        path: "product-catalog",
        loadChildren: () =>
          import("./../../Pages/Product-Catalog/product-catalog.module").then(
            (modules) => modules.ProductCatalogModule
          ),
        canActivate: [AuthGuard],
      },
      {
        path: "logistics",
        loadChildren: () =>
          import(
            "./../../Pages/Logistic-Manage-Order/logistic-manage-order.module"
          ).then((modules) => modules.LogisticManageOrderModule),
        canActivate: [AuthGuard],
      },
      {
        path: "sales-edit",
        loadChildren: () =>
          import("./../../Pages/Sales/sales.module").then(
            (modules) => modules.SalesModule
          ),
        canActivate: [AuthGuard],
      },

      {
        path: "brands",
        loadChildren: () =>
          import("./../../Pages/Brands/brands.module").then(
            (modules) => modules.BrandsModule
          ),
        canActivate: [AuthGuard],
      },

      // {
      //   path: "brands",
      //   loadChildren: () =>
      //     import("./../../Pages/Brands/brands.module").then(
      //       (modules) => modules.BrandsModule
      //     ),
      //   canActivate: [AuthGuard],
      // },
      // {
      //     path: 'supplier',
      //     loadChildren: () => import('./../../Pages/Supplier/supplier.module').then(module => module.SupplierModule)
      // }
      // {
      //     path: 'manage-orders',
      //     loadChildren: () => import('./../../Pages/MariHub-Sales-Manage-Orders/marihub-sales-manage-orders.module').then(modules => modules.MarihubSalesManageOrdersModule),
      //     canActivate: [AuthGuard]
      // },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainLayoutRoutingModule {}
